export enum ContextType {
  COLLECTION = "COLLECTION",
  PORTFOLIO = "PORTFOLIO",
  RESEARCH = "RESEARCH",
}
